import { httpClient2 } from 'src/infrastructure/admi-client/http-client';
import {
    AddBuildingToAssetRequest,
    AddBuildingToAssetResponse,
    CreateRealEstateAssetRequest,
    CreateServiceAssetMappingRequest,
    RealEstateAsset,
    RealEstateAssetHistory,
    RemoveBuildingFromAssetResponse,
    ServiceAssetMapping,
    ServicesByDealResponse,
    UpdateRealEstateAssetRequest,
} from './real-estate-asset-management.dto';

export const admiRealEstateAssetService = {
    async createRealEstateAsset(request: CreateRealEstateAssetRequest): Promise<RealEstateAsset> {
        const response = await httpClient2.post<RealEstateAsset>('/v1/real-estate-assets', request);
        return response.data;
    },

    async getRealEstateAsset(id: string, signal?: AbortSignal): Promise<RealEstateAsset> {
        const response = await httpClient2.get<RealEstateAsset>(`/v1/real-estate-assets/${id}`, { signal });
        return response.data;
    },

    async updateRealEstateAsset(id: string, request: UpdateRealEstateAssetRequest): Promise<RealEstateAsset> {
        const response = await httpClient2.patch<RealEstateAsset>(`/v1/real-estate-assets/${id}`, request);
        return response.data;
    },

    async addBuildingToAsset(assetId: string, request: AddBuildingToAssetRequest): Promise<AddBuildingToAssetResponse> {
        const response = await httpClient2.patch<AddBuildingToAssetResponse>(
            `/v1/real-estate-assets/${assetId}/buildings`,
            request,
        );
        return response.data;
    },

    async removeBuildingFromAsset(assetId: string, buildingId: string): Promise<RemoveBuildingFromAssetResponse> {
        const response = await httpClient2.delete<RemoveBuildingFromAssetResponse>(
            `/v1/real-estate-assets/${assetId}/buildings/${buildingId}`,
        );
        return response.data;
    },

    async getRealEstateAssetServices(assetId: string): Promise<ServicesByDealResponse> {
        const response = await httpClient2.get<ServicesByDealResponse>(`/v1/real-estate-assets/${assetId}/services`);
        return response.data;
    },

    async getUnassignedServices(): Promise<ServicesByDealResponse> {
        const response = await httpClient2.get<ServicesByDealResponse>('/v1/services/unassigned');
        return response.data;
    },

    async createServiceAssetMapping(
        serviceId: string,
        request: CreateServiceAssetMappingRequest,
    ): Promise<ServiceAssetMapping> {
        const response = await httpClient2.post<ServiceAssetMapping>(
            `/v1/services/${serviceId}/asset-mapping`,
            request,
        );
        return response.data;
    },

    async deleteServiceAssetMapping(serviceId: string): Promise<void> {
        await httpClient2.delete<void>(`/v1/services/${serviceId}/asset-mapping`);
    },

    async getRealEstateAssetHistory(assetId: string, limit = 10): Promise<RealEstateAssetHistory> {
        const response = await httpClient2.get<RealEstateAssetHistory>(`/v1/real-estate-assets/${assetId}/history`, {
            params: { limit },
        });
        return response.data;
    },
};
